import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getFentraGroups = api(async function fentraGroups({ profileId } = {}) {
    return await query(
        gql`
            query fentraGroups($profileId: ID!) {
                fentraGroups(profileId: $profileId) {
                    _id
                    profileId
                    externalId
                    displayName
                    description
                    memberExternalIds
                }
            }
        `,
        { profileId },
        { returns: "fentraGroups" }
    )
})
